import { Flex, Text } from '@chakra-ui/react';
import { MobileView } from 'react-device-detect';
import { useNavigate } from 'react-router-dom';
import { BackIcon } from '../iconComponents/BackIcon';
import { MobileFooter } from './MobileFooter';
import { MobileHeader } from './MobileHeader';

interface MobileViewProps {
    title: string;
    titleColor: string;
    titleBackgroundColor: string;
    children?: React.ReactNode;
    customBanner?: React.ReactNode;
    isLoading: boolean;
}

export const MobileViewPage: React.FC<MobileViewProps> = ({
    title,
    titleColor,
    titleBackgroundColor,
    children,
    customBanner,
    isLoading,
}) => {
    const navigate = useNavigate();

    return (
        <MobileView>
            <Flex className={'mobile-container'}>
                <MobileHeader isLoading={isLoading} color={titleBackgroundColor} />
                {customBanner ? (
                    customBanner
                ) : (
                    <Flex
                        className={'mobile-title-bar'}
                        backgroundColor={titleBackgroundColor}
                        color={titleColor}
                    >
                        <Flex className="mobile-title-back" onClick={() => navigate(-1)}>
                            <BackIcon />
                        </Flex>
                        <Text>{title}</Text>
                    </Flex>
                )}
                {children}
                <MobileFooter />
            </Flex>
        </MobileView>
    );
};
